import formatTools from "../formatTools";
import crc from "../crc";

const CONFIGKEYS = {
    "alert": "8ae18244534c524db029b0d36afaf313",
    "product": "72fa4b3f947a1a4adc262e75a20a03d4",
    "seller": "b6fcc2ac1b733e7b7de4bba09267c5e9",
    "franchise": "9ed4f522170ee986c74df17843445b26",
}

class Inquiry {
    constructor(request) {
        this.request = request;
        this.endpoint = "contactus"
    }

    GetHash = (body) => {
        // Get timestamp and remove non-digit characters
        const currentTimestamp = formatTools.getDateStr().replace(/\D/g, "");
        // Convert object to string
        const bodyStr = JSON.stringify(body);

        // Hash the combination of currentTimeStamp and payload
        var hashVal = crc.calculateCRC32(currentTimestamp + bodyStr);
        // Get yyymmdd from currentTimeStamp then convert to hex value
        var dateHex = parseInt(currentTimestamp.substring(1, 8), 10).toString(16).padStart(6, "0");
        // Get hhiiss from currentTimeStamp then convert to hex value
        var timeHex = parseInt(currentTimestamp.substring(8), 10).toString(16).padStart(5, "0");

        // Combine hashVal, dateHex, and timeHex into a 19-character hex (HHHDDDDDDHHTTTTTHH)
        const finalHash =
            hashVal.substring(0, 3) +
            dateHex +
            hashVal.substring(3, 5) +
            timeHex +
            hashVal.substring(5);

        return finalHash;
    }

    SendInquiry = (type, body) => {
        const hash = this.GetHash(body);

        const inquiryType = CONFIGKEYS.hasOwnProperty(type) ? type : "alert";

        let subject = "";

        if (body.hasOwnProperty('fields')) {
            let nameField = body.fields.find(field => field.label.indexOf("Name") > 0)

            if (nameField !== undefined) {
                subject = nameField.value
            }
        }

        return this.request.send(
            `${this.endpoint}/${inquiryType}`,
            'POST',
            body,
            undefined,
            undefined,
            {
                "configkey": CONFIGKEYS[inquiryType],
                "hash": hash,
                ...(subject.length > 0 ? {"subject": subject} : {})
            }
        )
    }
}

export default Inquiry;